import CountryTagDataReference from './CountryTagDataReference'
import NorthAmericaAddress from './NorthAmericaAddress'

const ContactInformation = `
  ${CountryTagDataReference}
  ${NorthAmericaAddress}
  fragment ContactInformation on CreatorContactInformation {
    email
    countryTags {
      ...CountryTagDataReference
    }
    address {
      ...NorthAmericaAddress
    }
  }
`
export default ContactInformation
